module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-40.3b631b14.jpg";